import { EditCoverGallerySelection } from "src/screens/(internal)/EditCoverGalleryModal/types";
import { enumNever } from "src/shared/helpers/generalHelpers";
import writeCoverUploadData from "./writeCoverUploadData";

const handleEditCoverSave = async (selection: EditCoverGallerySelection) => {
	const { variant } = selection;
	switch (variant) {
		case "GatheringPhotos":
			await selection.config.onSave({
				ownerId: selection.ownerId,
				photoId: selection.photoId,
			});
			return;
		case "Posters":
			await selection.config.onSave({
				publicAssetId: selection.publicAssetId,
			});
			return;
		case "Upload":
			const url = await selection.config.getUploadUrl();
			await writeCoverUploadData(selection, url);
			await selection.config.onSave?.({
				imageWriteUrl: url,
			});
			return;
		case "AIGeneration":
			await selection.config.onSave({
				generationId: selection.generationId,
			});
			return;
		case "Initial":
			return;
		default:
			return enumNever(variant);
	}
};
export default handleEditCoverSave;
